module.exports = __webpack_public_path__ + "static/media/estrellas_blancas_mobile.28da1538.svg";